<template>
  <listProductsComponent/>
</template>
  
<script>
import listProductsComponent from "@/views/products/pages/list_products/components/list_products_component.vue";


export default {
  name: "products",
  components: {
    listProductsComponent,
  },
};
</script>
  
<style lang="css" scoped>


</style>